import React, { SVGProps } from 'react'

/**
 * Feature-local "adjust limit" glyph for the ••• actions menu (matches the
 * design prototype). Lives here rather than in src/components/Svgs, which
 * `gen-svg-components` wipes and regenerates from src/assets/svgs — this has no
 * source asset.
 */
const SvgAdjustLimit = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M3 6h9M15 6h2M11 4v4M3 13h2M8 13h9M6 11v4"
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgAdjustLimit
